module.exports = __webpack_public_path__ + "files/5f0f5ba1f9ca308447e81ed3e26eadd6.png";